import React from "react";
import { Box, Paper } from "@mui/material";
import { brand, shadow } from "../../theme/tokens";

/**
 * Shared branded wrapper for the standalone auth pages (login, register, verify,
 * forgot/reset). Dark purple gradient background + centered white card. These
 * pages render OUTSIDE the dashboard shell, so the card provides the surface.
 */
const AuthShell = ({ children, maxWidth = 420 }) => (
  <Box
    sx={{
      minHeight: "100dvh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      p: 2,
      backgroundImage: `linear-gradient(135deg, ${brand.purpleDeep} 0%, ${brand.purple} 100%)`,
    }}
  >
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        maxWidth,
        p: { xs: 3, sm: 4 },
        borderRadius: 4,
        backgroundColor: "background.paper",
        boxShadow: shadow.overlay,
      }}
    >
      {children}
    </Paper>
  </Box>
);

export default AuthShell;
